import type { BrandConfig } from './types';

export const eduConfig: BrandConfig = {
  key: 'edu',
  isDefault: false,
  subdomain: 'edu',
  logo: '/brands/amai/logo.png',
  title: '界墨AI - 领先的AI模型与创作者社区',
  siteName: 'AME AI',
  allowedCreationTabs: ['text', 'image', 'video', 'tools'],
  payment: {
    productName: 'AME平台付费服务协议',
    productNameKey: 'payment.ameProductName',
  },
  agreementTabs: [
    { key: 'user-agreement', label: 'AME平台付费协议', labelKey: 'agreement.tabAmePayment' },
    { key: 'ricegrain-rules', label: '米粒值规则说明', labelKey: 'agreement.tabRiceGrain' },
    { key: 'privacy-policy', label: '用户协议及隐私政策', labelKey: 'agreement.tabPrivacy' },
    { key: 'enterprise-service-agreement', label: '企业服务协议', labelKey: 'agreement.tabEnterprise' },
  ],
  logoDisplay: {
    mode: 'text',
    text: 'AME AI 校园版',
    showGlow: true,
    textStyle: { fontSize: '18px', fontWeight: '500' },
  },
  logoClickable: false,
  hiddenSidebarSections: ['ricegrain', 'membership', 'ricegrain-divider'],
};
